import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.nim = bracketIndenting({
	line: "#",
})
